const reducer = (state: any) => {
  return {
    ...state,
    giftCardToken: null,
    giftCardValidationNonce: null,
    waiting: false,
  };
};

export default reducer;
